import React from "react";
import { Title } from "@mantine/core";

export interface H1Props {
  title: string;
}

const PageTitle = ({ title }: H1Props): React.ReactElement => {
  return <Title order={1}>{title}</Title>;
};

export default PageTitle;
